import { useMemo } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useGetActivityTypes } from '@/query/queries/activity/useGetActivityTypes';
import { useUserStore } from '@/store/userStore';
import { MenuList, Option, ValueContainer } from './components';
import s from './index.module.scss';

export const OperationTypeSelect = ({ selected = [], menuPlacement, onChange }) => {
  const { t } = useTranslation('activity');
  const { accountType } = useUserStore();
  const { data: activityTypes } = useGetActivityTypes({ account_type: accountType });

  const options = useMemo(() => {
    return activityTypes
      ? Object.keys(activityTypes).map(key => ({
          value: key,
          label: activityTypes[key],
        }))
      : [];
  }, [activityTypes]);

  const values = useMemo(() => {
    return options?.filter(option => selected.includes(option.value));
  }, [selected, options]);

  return (
    <div className={s.wrapper}>
      <div className="f-small-accent">{t('operation_type_select.operation_type')}</div>
      <Select
        value={values}
        onChange={options => onChange(options.map(({ value }) => value))}
        className={s.select}
        classNamePrefix="operation_type"
        name="operation_type"
        isSearchable={false}
        options={options}
        menuPlacement={menuPlacement}
        isMulti
        components={{ ValueContainer, MenuList, Option }}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        placeholder={t('operation_type_select.all_operations')}
      />
    </div>
  );
};
